import axios from 'axios';
import { ladeToken } from 'core/features/auth/authApi';

/**
 * Axios-Client für die Aktien-Tiefenanalyse (`/api/analyse`).
 *
 * Relative baseURL: nginx leitet `/api/analyse` an den analyse-service weiter.
 * Antworten kommen im ApiResponse-Wrapper `{ success, message, data }`; die
 * Helfer geben direkt `data` zurück. Die Analyse fragt mehrere externe Quellen
 * live ab – daher ein großzügiger Timeout.
 */
const analyseApi = axios.create({
  baseURL: '/api/analyse',
  timeout: 45000,
});

analyseApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const unwrap = (response) => response.data?.data;

// Startet eine neue Analyse (Name + ISIN) und liefert das Ergebnis.
export const starteAnalyseApi = ({ name, isin }) =>
  analyseApi.post('', { name, isin }).then(unwrap);

// Frühere Analysen einer ISIN (neueste zuerst).
export const fetchAnalyseHistorieApi = (isin) =>
  analyseApi.get(`/${encodeURIComponent(isin)}/history`).then(unwrap);

export default analyseApi;
